import determineTarget from './determine-target';

export default function setupAccordion() {
	document.addEventListener( 'click', event => {
		let toggle = event.target;

		// If not the literal toggle, check if it's a decendent of one
		if ( ! toggle.classList.contains( 'js-accordion-toggle' ) ) {
			toggle = toggle.closest( '.js-accordion-toggle' );
		}

		// No match, ignore event
		if ( ! toggle ) {
			return;
		}

		event.preventDefault();

		// Get target, abort if not found
		const content = determineTarget( toggle );
		if ( ! content ) {
			return;
		}

		// Toggle status
		if ( toggle.getAttribute( 'aria-expanded' ) === 'false' ) {
			// Animate to "auto" height
			content.style.setProperty( '--open-height', `${ content.scrollHeight }px` );

			// Mark as open
			toggle.setAttribute( 'aria-expanded', true );
			content.setAttribute( 'aria-hidden', false );

			// If it's within a group, close all others
			const group = toggle.closest( '.js-accordion-group' );
			if ( group ) {
				group.querySelectorAll( '.js-accordion-toggle[aria-expanded="true"]' )
					.forEach( otherToggle => {
						// Don't change the current toggle
						if ( otherToggle === toggle ) {
							return;
						}

						// Mark as closed
						otherToggle.setAttribute( 'aria-expanded', false );
						const otherContent = determineTarget( otherToggle );
						if ( otherContent ) {
							// Animate from current height
							otherContent.style.setProperty( '--open-height', `${ otherContent.clientHeight }px` );
							otherContent.setAttribute( 'aria-hidden', true );
						}
					} );
			}
		} else {
			// Animate from current height
			content.style.setProperty( '--open-height', `${ content.clientHeight }px` );

			// Mark as closed
			toggle.setAttribute( 'aria-expanded', false );
			content.setAttribute( 'aria-hidden', true );
		}
	} );

	// Initialize accordion expanded states
	document.querySelectorAll( '.js-accordion-toggle' )
		.forEach( toggle => {
			// If marked as auto open, leave as open
			const autoOpen = toggle.classList.contains( 'auto-open' );
			toggle.setAttribute( 'aria-expanded', autoOpen );

			const content = determineTarget( toggle );
			if ( content ) {
				content.setAttribute( 'aria-hidden', ! autoOpen );
			}
		} );
}
